<template>
  <div class="generalInfoReservation">
    <div class="info" v-if="activeDelivery.phoneNumber">
      <p>{{ $t('mobilePhone') }}</p>
      <span>{{ activeDelivery.phoneNumber }}</span>
    </div>
    <div class="info" v-if="activeDelivery.deliveryStatus">
      <p>{{ $t('deliveryStatus') }}</p>
      <span>{{ $t(activeDelivery.deliveryStatus) }}</span>
      <span v-if="activeDelivery.deliveryStatus === 'expired'">
        ({{ $t(getDeliveryStatus()) }})
      </span>
    </div>
    <div class="info">
      <p>{{ $t('ssn') }}</p>
      <span>{{ getDataSSN() }}</span>
      <Button
        v-if="!isSSN"
        class="ssn_btn"
        variant="notBordered"
        :title="$t('show')"
        @click="showSsn"
      />
    </div>
    <div class="info" v-if="activeDelivery.pickupSsn">
      <p>{{ $t('ssnPickUp') }}</p>
      <span>{{ getDataOtherSSN() }}</span>
      <Button
        v-if="!isOtherSSN"
        class="ssn_btn"
        variant="notBordered"
        :title="$t('show')"
        @click="showOtherSsn"
      />
    </div>
    <div class="info" v-if="!isAddDescription && activeDelivery.expiredTime">
      <p>{{ $t('timeExpired') }}</p>
      <span>{{ dateTime(activeDelivery.expiredTime) }}</span>
    </div>
    <div class="info" v-if="activeDelivery.deliveryId">
      <p>{{ $t('kolliID') }}</p>
      <span>
        {{
          getIds(
            activeDelivery.deliveryId,
            activeDelivery.additionalDeliveryIds
          )
        }}
      </span>
    </div>
    <div
      class="info"
      v-if="!isAddDescription && activeDelivery.fulfillment_order_id"
    >
      <p>{{ $t('fulfillment_order_id') }}</p>
      <span>{{ activeDelivery.fulfillment_order_id }}</span>
    </div>
    <div class="info" v-if="activeDelivery?.lokerId || activeDelivery?.shelf">
      <p>{{ $t('lockerIdOrShelf') }}</p>
      <span>{{ getLockerIdOrShelf(activeDelivery) }}</span>
    </div>
    <div class="info" v-if="!isAddDescription">
      <p>{{ $t('includesDrug') }}</p>
      <span>{{ getIsDrud(activeDelivery.is_drug) }}</span>
    </div>
    <div class="info" v-if="activeDelivery.lockerId">
      <p>{{ $t('lockerID') }}</p>
      <span>{{ activeDelivery.lockerId.join(', ') }}</span>
    </div>
    <div class="info" v-if="!isAddDescription && activeDelivery.order_id">
      <p>{{ $t('order_id') }}</p>
      <span>{{ activeDelivery.order_id }}</span>
    </div>
    <div
      class="info"
      v-if="activeDelivery.deliveryTime || activeDelivery.deliveryUserName"
    >
      <p>{{ $t('delivered') }}</p>
      <span>
        {{ activeDelivery.deliveryUserName }}
        {{ dateTime(activeDelivery.deliveryTime) }}
      </span>
    </div>
    <div
      class="info"
      v-if="
        !isAddDescription &&
        (activeDelivery.deleteTime || activeDelivery.deleteUserName)
      "
    >
      <p>{{ $t('deleted') }}</p>
      <span>
        {{ activeDelivery.deleteUserName }}
        {{ dateTime(activeDelivery.deleteTime) }}
      </span>
    </div>
    <div
      class="info"
      v-if="
        !isAddDescription &&
        (activeDelivery.destroyTime || activeDelivery.destroyUserName)
      "
    >
      <p>{{ $t('destroy') }}</p>
      <span>
        {{ activeDelivery.destroyUserName }}
        {{ dateTime(activeDelivery.destroyTime) }}
      </span>
    </div>
    <div
      class="info"
      v-if="
        !isAddDescription &&
        (activeDelivery.cancelTime || activeDelivery.cancelUserName)
      "
    >
      <p>{{ $t('cancelTime') }}</p>
      <span>
        {{ activeDelivery.cancelUserName }}
        {{ dateTime(activeDelivery.cancelTime) }}
      </span>
    </div>
    <div
      class="info"
      v-if="
        !isAddDescription &&
        (activeDelivery.lostTime || activeDelivery.lostUserName)
      "
    >
      <p>{{ $t('lostTime') }}</p>
      <span>
        {{ activeDelivery.lostUserName }}
        {{ dateTime(activeDelivery.lostTime) }}
      </span>
    </div>
    <div class="info" v-if="activeDelivery.reservedUserId">
      <p>{{ $t('reserved') }}</p>
      <span>
        {{
          activeDelivery.reservedUserId === 'API'
            ? 'API'
            : activeDelivery.reservedUserName
        }}
        {{ dateTime(activeDelivery.reservedTime) }}
      </span>
    </div>
    <div
      class="info"
      v-if="activeDelivery.assignedUserName || activeDelivery.assignedTime"
    >
      <p>{{ $t('assignedUserName') }}</p>
      <span>
        {{ activeDelivery.assignedUserName }}
        {{ dateTime(activeDelivery.assignedTime) }}
      </span>
    </div>
    <div class="info" v-if="activeDelivery.givenOutUserName">
      <p>{{ $t('givenOutUserName') }}</p>
      <span>
        {{ activeDelivery.givenOutUserName }}
      </span>
    </div>
    <div class="info" v-if="activeDelivery.pickupTime">
      <p>{{ $t('pickupTime') }}</p>
      <span>
        {{ dateTime(activeDelivery.pickupTime) }}
      </span>
    </div>
    <div
      class="info"
      v-if="
        !isAddDescription &&
        (activeDelivery.removedUserName || activeDelivery.removedTime)
      "
    >
      <p>{{ $t('removed') }}</p>
      <span>
        {{ activeDelivery.removedUserName }}
        {{ dateTime(activeDelivery.removedTime) }}
      </span>
    </div>
    <div
      class="info"
      v-if="!isAddDescription && activeDelivery.resendSMSCounter"
    >
      <p>{{ $t('resendSMSCounter') }}</p>
      <span>{{ activeDelivery.resendSMSCounter }}</span>
    </div>
    <div
      class="info"
      v-if="!isAddDescription && activeDelivery.resendSMSTimestamps"
    >
      <p>{{ $t('resendSMSTimestamps') }}</p>
      <span>{{ dateTime(isLastTime) }}</span>
    </div>
    <div class="info" v-if="isAddDescription && activeDelivery.orderExpired">
      <p>{{ $t('orderExpired') }}</p>
      <span>{{ activeDelivery.orderExpired }}</span>
    </div>
    <div class="info" v-if="isAddDescription && activeDelivery.causeOfAlarm">
      <p>{{ $t('causeOfAlarm') }}</p>
      <span>{{ activeDelivery.causeOfAlarm }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import moment from 'moment';
import { DataReservations } from '@/store/modules/pharmacy/types';

@Options({
  name: 'GeneralInfoReservation',
  props: ['isAddDescription', 'openGeneralInfoReservation', 'activeDelivery'],
  data() {
    return {
      isSSN: false,
      isOtherSSN: false
    };
  },
  computed: {
    ...mapState('pharmacy', ['decodedSsn']),
    isLastTime() {
      return this.activeDelivery.resendSMSTimestamps[
        this.activeDelivery.resendSMSTimestamps.length - 1
      ].sendTime;
    }
  },
  created() {
    if (this.openGeneralInfoReservation === true) {
      this.getDecodedSsn();
    }
  },
  methods: {
    ...mapActions('pharmacy', ['getDeliveryShowDecodedSsn']),
    dateTime(value: string) {
      return moment(value).format('DD.MM.YYYY HH:mm');
    },
    getIds(deliveryId: string, additionalDeliveryIds: Array<string>) {
      if (!additionalDeliveryIds[0] && !additionalDeliveryIds[1]) {
        return deliveryId;
      } else if (additionalDeliveryIds[1] !== '') {
        return deliveryId + ', ' + additionalDeliveryIds.join(', ');
      } else if (additionalDeliveryIds[1] === '') {
        return deliveryId + ', ' + additionalDeliveryIds.join('');
      }
    },
    getDeliveryStatus() {
      if (
        this.activeDelivery.deliveryStatus === 'expired' &&
        !this.activeDelivery.deliveryTime
      ) {
        return 'reservation';
      } else if (
        this.activeDelivery.deliveryStatus === 'expired' &&
        this.activeDelivery.deliveryTime
      ) {
        return 'delivery';
      } else {
        return '';
      }
    },
    getLockerId(item: Array<string>) {
      return item?.join(', ');
    },
    getLockerIdOrShelf(data: DataReservations) {
      if (data?.shelf) {
        return data?.shelf
          .map((item: string) =>
            item === 'cooling' ? this.$t('cooling') : item.toUpperCase()
          )
          .join(', ');
      } else {
        return this.getLockerId(data?.lockerId);
      }
    },
    getIsDrud(value: boolean) {
      if (value) {
        return `${this.$t('yes')}`;
      } else {
        return `${this.$t('no')}`;
      }
    },
    async getDecodedSsn() {
      this.loading = true;

      const params = {
        docId: this.activeDelivery?.docId,
        deliveryId: this.activeDelivery?.deliveryId,
        reservedTime: this.activeDelivery?.reservedTime
      };

      await this.getDeliveryShowDecodedSsn(params);

      this.loading = false;
    },
    showSsn() {
      this.isSSN = true;
    },
    showOtherSsn() {
      this.isOtherSSN = true;
    },
    getDataSSN() {
      if (this.isSSN) {
        return this.decodedSsn.ssn.length
          ? this.decodedSsn.ssn
          : this.$t('noSsn');
      } else {
        return '************';
      }
    },
    getDataOtherSSN() {
      if (this.isOtherSSN) {
        return this.decodedSsn.pickupSsn?.length
          ? this.decodedSsn.pickupSsn
          : this.$t('noSsn');
      } else {
        return '************';
      }
    }
  }
})
export default class GeneralInfoReservation extends Vue {}
</script>

<style lang="scss" scoped>
.generalInfoReservation {
  width: 283px;
  height: 275px;
  padding: 16px;
  background-color: $light-grey;
  border: 1px solid $border;
  border-radius: 8px;
  overflow-y: scroll;
  margin-bottom: 23px;
  .info {
    margin-bottom: 25px;
    background-color: $light-grey;
    p {
      color: $label;
      line-height: 14px;
      font-size: $twelveSize;
      background-color: $light-grey;
    }
    span {
      color: $mid-grey;
      line-height: 14px;
      font-size: $fourteenSize;
      background-color: $light-grey;
    }
    .ssn_btn {
      width: 0;
      height: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
